"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconHamburger = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("rect", {
    x: "5.67",
    y: "14.54",
    width: "58.67",
    height: "7.71",
    rx: "3.85",
    ry: "3.85"
  }), _react["default"].createElement("rect", {
    x: "5.67",
    y: "31.15",
    width: "58.67",
    height: "7.71",
    rx: "3.85",
    ry: "3.85"
  }), _react["default"].createElement("rect", {
    x: "5.67",
    y: "47.75",
    width: "58.67",
    height: "7.71",
    rx: "3.85",
    ry: "3.85"
  })),
  height: undefined,
  width: undefined
});
IconHamburger.displayName = 'IconHamburger';
var _default = IconHamburger;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/hamburger.js
// module id = 575
// module chunks = 0